export default "/assets/images/peacekeeper-icon.png?4430d8b23e2a621bf583cfbb8a49fd52";